// extracted by mini-css-extract-plugin
export default {"root":"publicPage_root__PHGc6","innerWrapper":"publicPage_innerWrapper__ohcYd","footer":"publicPage_footer__G8+lE","policyLinks":"publicPage_policyLinks__U1LBA"};